import { withFormik } from 'formik';

import { ISettings, PageProps } from 'types';
import { getErrorMessage } from 'utilities';

import { SettingsForm } from '..';

export const SettingsFormWrapper = withFormik<ISettings & PageProps<ISettings>, any>({
  // Transform outer props into form values
  mapPropsToValues: ({
    status,
    features,
    passwordRequirements,
    cache,
    payments,
    creditCheck,
    systemMaintenance,
    setSystemMessageOn,
    systemMessageOn,
  }): ISettings => {
    return {
      status,
      features,
      passwordRequirements,
      cache,
      payments,
      creditCheck,
      systemMaintenance: {
        showSystemMaintenanceMessage: systemMaintenance?.showSystemMaintenanceMessage || false,
        systemMaintenanceMessage: systemMaintenance?.systemMaintenanceMessage || '',
        systemMaintenanceShowUntilTime: systemMaintenance?.systemMaintenanceShowUntilTime,
      },
      setSystemMessageOn,
      systemMessageOn,
    };
  },

  handleSubmit: async (props, formik) => {
    const { name, endpoint, values, ...rest } = props;
    const {
      props: { onSubmit, onSuccessToast, onFailureToast },
    } = formik;

    if (onSubmit) {
      try {
        await onSubmit(rest);
        onSuccessToast && onSuccessToast();
        props.setSystemMessageOn(props.systemMaintenance.showSystemMaintenanceMessage);
      } catch (error) {
        const err = error as any;
        const msg = getErrorMessage(error) || err.message;
        onFailureToast && onFailureToast(msg);
      }
    }
  },
})(SettingsForm);
